
import { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { apis } from "../../services/Api";
import "./MyCalendar.css";
import calIcon from "../../../src/assets/images/vc-callendar.svg"

const MyCalendar = () => {
    const navigate = useNavigate();

    const [date, onChange] = useState(new Date());
    const [myCalendarData, setMyCalendarData] = useState([]);
    const [calendarDate, setCalendarDate] = useState();
    const [highlightedDates, setHighlightedDates] = useState([]);
    const [showCalendarView, setShowCalendarView] = useState(true);

    const profile = useSelector((state) => state.userProfile.userProfile);

    const TodayDate = moment(new Date()).format("MMM Do YYYY");

    const init = async (profile) => {
        const calData = await apis.getMyCalendar(profile?.id);

        const filtered =
      calData?.data?.filter((cal) => {
          const eventDate = new Date(cal?.attributes?.dateStart);
          return !Number.isNaN(eventDate.getTime());
      }) || [];

        setMyCalendarData(filtered);

        const expectedDates = new Set(
            filtered.map(
                (cal) =>
                    moment(cal?.attributes?.dateStart)
                        .hours(0)
                        .minutes(0)
                        .seconds(0)
                        .format("ddd MMM D YYYY HH:mm:ss [GMT]ZZ") + " (India Standard Time)"
            )
        );
        setHighlightedDates(Array.from(expectedDates));
    };

    useEffect(() => {
        if (profile) init(profile);
    }, [profile]);

    const filterdata =
    myCalendarData?.filter(
        (d) =>
            moment(d?.attributes?.dateStart).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
    ) || [];

    const finddata = filterdata.find(
        (d) =>
            moment(d?.attributes?.dateStart).format("YYYY-MM-DD") ===
      moment(date).format("YYYY-MM-DD")
    )?.attributes?.dateStart;

    const tileClassName = ({ date }) => {
        const currentYear = new Date().getFullYear();

        for (let eventDate of highlightedDates) {
            if (
                new Date(eventDate).getDate() === date.getDate() &&
        new Date(eventDate).getMonth() === date.getMonth() &&
        new Date(eventDate).getFullYear() === date.getFullYear()
            ) {
                return "highlight-date";
            }
        }
        if (date.getFullYear() === currentYear) return "highlighted-year";
        return "";
    };

    const handleDateClick = (e) => {
        setCalendarDate(moment(e).format("MMM Do YYYY"));
        // Replace the days grid area with event list (inside the same container)
        setShowCalendarView(false);
    };

    const backToCalendar = () => setShowCalendarView(true);

    const goToCourseDetails = (event, cid) => {
        event.preventDefault();
        if (!cid) return;
        navigate(`/coursedetails/${cid}`, { state: { crumbs: [{ label: "Home", url: "/" }] } });
    };

    return (
        <div className="calendar-block">
            <div className={`calendar-inline ${showCalendarView ? "" : "show-events"}`}>
                <Calendar
                    onChange={onChange}
                    value={date}
                    tileClassName={tileClassName}
                    onClickDay={handleDateClick}
                    className="calendar-root"
                    style={
                        moment(finddata).format("YYYY-MM-DD") !== moment(date).format("YYYY-MM-DD")
                            ? { color: "black" }
                            : { color: "red", background: "pink" }
                    }
                />

                {!showCalendarView && (
                    <div className="event-inline-panel">
                        <div className="detail-header">
                            <button className="back-button" aria-label="Back to calendar" onClick={backToCalendar}>
                ←
                            </button>
                            <span className="title">
                                {calendarDate || TodayDate}
                                {filterdata?.length > 0
                                    ? ` (${filterdata.length} ${filterdata.length === 1 ? "Event" : "Events"})`
                                    : ""}
                            </span>
                            <div className="event-enroll-card">
                                {filterdata && filterdata.length > 0 ? (
                                    filterdata.map((cal) => {
                                        const newDate = cal?.attributes?.dateStart;
                                        const sessionName = cal?.attributes?.sessionName;
                                        const course = cal?.attributes?.course;
                                        const enrolled = cal?.attributes?.enrolled;

                                        if (!course) return null;

                                        return (
                                            <div className="enroll-list-item" key={cal.id}>
                                                <div className="enroll-list-item-img-placeholder">
                                                    <img src={calIcon} alt="" />
                                                </div>
                                                <div className="event-sm">
                                                    <button
                                                        className="btn primary-btn event-btn"
                                                        onClick={(e) =>
                                                            goToCourseDetails(e, cal?.relationships?.course?.data?.id)
                                                        }
                                                    >
                          View Details
                                                    </button>
                                                    
                                                    <div className="event-head">{sessionName}</div>

                                                    <div className="event-time">
                                                        {`${new Date(newDate).toLocaleTimeString([], {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true
                                                        })} - ${new Date(cal?.attributes?.dateEnd).toLocaleTimeString([], {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true
                                                        })}`}
                                                        {enrolled ? (
                                                            <span className="enrollStatus status-enrolled p-1 mx-2 ">Enrolled</span>
                                                        ) : (<span className="enrollStatus status-notenrolled p-1 mx-2 ">Not Enrolled</span>)}
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="no-events-message">
                                        <div className="text-center py-4">
                                            <i className="fa fa-calendar-o mb-3" aria-hidden="true"></i>
                                            <p>No event for selected date</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

            
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyCalendar;